/**
 * Canonical sets of positive and negative engagement actions.
 * Shared between @ownyou/ikigai (CompositionContext) and apps/consumer (EngagementLogger).
 *
 * IMPORTANT: If you add/remove actions here, update both consumers.
 */
export const POSITIVE_ACTIONS = new Set([
    'accepted', 'completed', 'loved', 'emoji_positive',
]);
export const NEGATIVE_ACTIONS = new Set([
    'dismissed', 'not_interested', 'emoji_negative',
]);
